(function () {
  function initPathwayMenu() {
    const buttons = document.querySelectorAll('.pc-mobile-menu-toggle');

    buttons.forEach(function (button) {
      if (button.dataset.pcMenuReady === 'true') return;
      button.dataset.pcMenuReady = 'true';

      const header = button.closest('.pc-header') || document.querySelector('.pc-header');
      const menu = document.querySelector('#pcMobileMenu') || document.querySelector('.pc-mobile-menu');

      if (!menu || !header) return;

      function closeMenu() {
        menu.classList.remove('is-open');
        button.classList.remove('is-open');
        header.classList.remove('is-menu-open');
        button.setAttribute('aria-label', 'Open menu');
      }

      button.addEventListener('click', function () {
        const isOpen = !menu.classList.contains('is-open');

        menu.classList.toggle('is-open', isOpen);
        button.classList.toggle('is-open', isOpen);
        header.classList.toggle('is-menu-open', isOpen);
        button.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
      });

      menu.addEventListener('click', function (event) {
        if (event.target === menu || event.target.closest('a')) {
          closeMenu();
        }
      });

      window.addEventListener('scroll', function () {
        header.classList.toggle('is-scrolled', window.scrollY > 20);
      }, { passive: true });

      header.classList.toggle('is-scrolled', window.scrollY > 20);
    });
  }

  document.addEventListener('DOMContentLoaded', initPathwayMenu);
  document.addEventListener('shopify:section:load', initPathwayMenu);
})();


(function () {

  const items = document.querySelectorAll('.pc-faq__item');

  items.forEach(item => {
    const btn = item.querySelector('.pc-faq__question');

    btn.addEventListener('click', () => {

      const isOpen = item.classList.contains('is-open');

      // close all
      items.forEach(i => i.classList.remove('is-open'));

      // open clicked if not already open
      if (!isOpen) {
        item.classList.add('is-open');
      }

    });

  });

})();

/* Header account menu (sections/pathway-header.liquid).
   Only rendered for signed-in customers. Progressive enhancement: the
   toggle is a real link to the account page; once this runs it becomes a
   disclosure button that opens "My Account" / "Sign out". */
(function () {
  function initPathwayAccountMenu() {
    document.querySelectorAll('[data-pc-account]').forEach(function (root) {
      if (root.dataset.pcAccountReady === 'true') return;

      const toggle = root.querySelector('[data-pc-account-toggle]');
      const menu = root.querySelector('[data-pc-account-menu]');
      if (!toggle || !menu) return;
      root.dataset.pcAccountReady = 'true';

      toggle.setAttribute('role', 'button');
      toggle.setAttribute('aria-haspopup', 'true');
      toggle.setAttribute('aria-expanded', 'false');

      function items() {
        return Array.prototype.slice.call(menu.querySelectorAll('a[href]'));
      }

      function isOpen() {
        return toggle.getAttribute('aria-expanded') === 'true';
      }

      function open(focusFirst) {
        menu.hidden = false;
        root.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        if (focusFirst) {
          const first = items()[0];
          if (first) first.focus();
        }
      }

      function close(returnFocus) {
        if (!isOpen()) return;
        menu.hidden = true;
        root.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        if (returnFocus) toggle.focus();
      }

      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        isOpen() ? close(false) : open(false);
      });

      toggle.addEventListener('keydown', function (event) {
        // role="button" on a link: Space must activate it too.
        if (event.key === ' ' || event.key === 'Spacebar') {
          event.preventDefault();
          isOpen() ? close(false) : open(true);
        } else if (event.key === 'ArrowDown') {
          event.preventDefault();
          open(true);
        } else if (event.key === 'Escape') {
          close(true);
        }
      });

      menu.addEventListener('keydown', function (event) {
        const list = items();
        const index = list.indexOf(document.activeElement);
        if (event.key === 'Escape') {
          event.preventDefault();
          close(true);
        } else if (event.key === 'ArrowDown' && list.length) {
          event.preventDefault();
          list[(index + 1) % list.length].focus();
        } else if (event.key === 'ArrowUp' && list.length) {
          event.preventDefault();
          list[(index - 1 + list.length) % list.length].focus();
        } else if (event.key === 'Home' && list.length) {
          event.preventDefault();
          list[0].focus();
        } else if (event.key === 'End' && list.length) {
          event.preventDefault();
          list[list.length - 1].focus();
        }
      });

      // Close when focus leaves the control (Tab away) or on outside tap/click.
      root.addEventListener('focusout', function (event) {
        if (event.relatedTarget && !root.contains(event.relatedTarget)) close(false);
      });

      document.addEventListener('click', function (event) {
        if (!root.contains(event.target)) close(false);
      });

      // Don't leave it open underneath the mobile menu drawer.
      document.querySelectorAll('.pc-mobile-menu-toggle').forEach(function (button) {
        button.addEventListener('click', function () { close(false); });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initPathwayAccountMenu);
  document.addEventListener('shopify:section:load', initPathwayAccountMenu);
})();
